import PageBanner from 'components/banners/PageBanner';
import { FeaturesLinks } from 'components/Features';
import React from 'react';
import { Container } from 'react-bootstrap';
// import teamWorkImage from 'assets/images/teamwork-polygon.png';
// import styles from './programs.module.scss';
import { Helmet } from 'react-helmet';
// import RequestDemoButton from 'components/RequestDemoButton';
// const REPORT_DATA = [
//   {
//     title: 'Case Management',
//     items: [
//       'Case Counts & Trends',
//       'Client Listing Details',
//       'Case Load Details',
//       'Follow-up and Referrals',
//     ],
//   },
//   {
//     title: 'Service Analytics',
//     items: [
//       'Service Details',
//       'Service Counts',
//       'Service Averages & Totals',
//       'Service Time & Costs',
//     ],
//   },
//   {
//     title: 'Compliance Reports',
//     items: [
//       'ROMA Next Gen',
//       'Organizational Performance Standard Tracking',
//       'Crisis to Thriving Scale Assessment Outcomes',
//       'Board Minutes & Meetings',
//     ],
//   },
//   {
//     title: 'Agency-wide Efficiency',
//     items: [
//       'Auditable Demographic Reports',
//       'Community Needs Assessments',
//       'Volunteer Analytics',
//       'Outreach Project Outcomes',
//     ],
//   },
// ];
const PROGRAM_DATA = [
  { href: '/csbg', name: 'CSBG' },
  { href: '/liheap', name: 'LIHEAP' },
  { href: '/head-start', name: 'Head Start' },
  { href: '/transportation', name: 'Transportation' },
  { href: '/victim-support-services', name: 'Victim Support Services' },
  // { href: '/nutrition', name: 'Nutrition' },
  { href: '/weatherization', name: 'Weatherization' },
  { href: '/case-management', name: 'Case Management' },
  { href: '/youth-programs', name: 'Youth Programs' },
  { href: '/housing-assistance', name: 'Housing Assistance' },
];
function Programs() {
  return (
    <div>
      <Helmet>
        <title>Programs - CAP60</title>
        <meta
          name="description"
          content="CAP60 is the leading data management solution provider. They offer different data management solutions. Contact us Now!."
        />
        <meta name="keywords" content="programs, cap60 programs" />
      </Helmet>
      <PageBanner
        title="Programs"
        subtitle="The One-Stop Source for your Data Management Needs"
      />
      <div className="floralbg-white">
        <Container className="overflow-auto">
          <div className="mt-5">
            <h3>The only data management & reporting source you need</h3>
            {/* <p>
              CAP60 is the leading data management firm in the country for
              several reasons. One of the primary ones is the magnitude of
              programs offered. No matter your agencies’ client services, CAP60
              has a module to help record and report your data.
            </p> */}
          </div>
          <FeaturesLinks
            data={PROGRAM_DATA}
            variant="primary"
            // title="Our Programs"
          />
        </Container>
      </div>
    </div>
  );
}
//
// function CommunityServices() {
//   return (
//     <div className={styles.communityServicesWrap}>
//       <Row className="align-items-center">
//         <Col md="5">
//           <Image src={teamWorkImage} fluid className="p-3 mb-4 mb-md-0" />
//         </Col>
//         <Col md="7">
//           <div className="heading">
//             <h2>Maximize agency-wide efficiency</h2>
//           </div>
//           <p>
//             CAP60 has designed a comprehensive and integrated data management
//             system that’s defined by ease of use and maximum agency-wide
//             efficiency. From LIHEAP to Employment Assistance, our web-based
//             system provides families the opportunity to participate in the
//             multiple programs offered by various local and state Community
//             Action Programs.
//           </p>
//           <p>
//             With CAP60 you will have the ability to integrate and map all agency
//             programs to ROMA Next Gen goals track outcomes for all programs. We
//             also create unduplicated client reports and agency-wide demographic
//             reports.
//           </p>
//           <RequestDemoButton />
//         </Col>
//       </Row>
//     </div>
//   );
// }

// function SampleReport() {
//   return (
//     <div className={styles.sampleReportWrapper}>
//       <Container>
//         <div className="heading">
//           <h2>Sample Reports</h2>
//         </div>
//         <Row>
//           {REPORT_DATA.map((rdata, idx) => (
//             <Col md="6" key={idx}>
//               <div className={styles.reportList}>
//                 <h3>{rdata.title}</h3>
//                 <ul>
//                   {rdata.items.map((item, idx) => (
//                     <li key={idx}>{item}</li>
//                   ))}
//                 </ul>
//               </div>
//             </Col>
//           ))}
//         </Row>
//       </Container>
//     </div>
//   );
// }
export default Programs;
